// Локальное зеркало «что сейчас смотрит пользователь» для подавления toast'ов.
// Серверный Redis watching гасит CREATE/email/push; клиентский toast-listener
// раньше всё равно показывал Sonner — при генерации темы вываливалась пачка
// «готово». Этот Set обновляет `useArtifactWatching`.

const watchingKeys = new Set<string>();

/** Включить/выключить локальный watching для набора groupKey. */
export function setLocalArtifactWatching(keys: readonly string[], watching: boolean): void {
	for (const key of keys) {
		if (!key) continue;
		if (watching) watchingKeys.add(key);
		else watchingKeys.delete(key);
	}
}

/** Пользователь на поверхности этого артефакта (или темы) прямо сейчас? */
export function isLocallyWatchingArtifact(groupKey: string | null | undefined): boolean {
	if (!groupKey) return false;
	return watchingKeys.has(groupKey);
}
